module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thick_rect_mask.ea827400.png";